module.exports = __webpack_public_path__ + "img/Blockdit.13666bb6.svg";